import numeral from 'numeral';
export default function shortenNumber(value, precision, roundingFunction) {
    if (precision === void 0) { precision = 1; }
    var format = "0.[".concat('0'.repeat(precision), "]a");
    return numeral(value || 0)
        .format(format, roundingFunction)
        .toUpperCase();
}
//# sourceMappingURL=shortenNumber.js.map